import { render, staticRenderFns } from "./AddQualificationModal.vue?vue&type=template&id=3f4c2385"
import script from "./AddQualificationModal.vue?vue&type=script&lang=ts"
export * from "./AddQualificationModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports